'use client';

import React from 'react';

import { Media } from '@/components/Media';
import { ModalForm } from '@/components/ModalForm';
import { Svg } from '@ui/svg';
import { Button } from '@ui/button';
import type { Misc, Media as MediaType } from '@/payload-types';

export const ConsultationOnline: React.FC<{
  title: string;
  name: string;
  position: string;
  price: string;
  photo: MediaType;
  misc: Misc;
}> = ({ title, name, position, price, photo, misc }) => {
  const { phones } = misc.refs;

  return (
    <section className="v-margin" data-name="ConsultationOnline">
      <div className="container">
        <div className="corners flex overflow-hidden bg-[#E9EDF4] md:flex-col">
          <div className="relative z-10 max-w-[700px] px-8 pt-[59px] pb-[64px] md:px-4 md:pt-[33px] md:pb-12">
            <h2 className="h3 relative mb-5 md:mb-5">
              {title}
              <div className="relative -mb-5 ml-[18px] inline-block rotate-[7.88deg] md:hidden">
                <svg
                  width="162"
                  height="49"
                  viewBox="0 0 162 49"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M26.1872 0.828613C23.0046 0.828613 19.9523 2.0929 17.7019 4.34333L2.87345 19.1718C-0.250746 22.296 -0.250743 27.3613 2.87345 30.4855L17.7019 45.3139C19.9523 47.5643 23.0046 48.8286 26.1872 48.8286L149.717 48.8286C156.344 48.8286 161.717 43.456 161.717 36.8286V12.8286C161.717 6.2012 156.344 0.828613 149.717 0.828613L26.1872 0.828613ZM13.2166 29.8286C15.978 29.8286 18.2166 27.59 18.2166 24.8286C18.2166 22.0672 15.978 19.8286 13.2166 19.8286C10.4552 19.8286 8.21659 22.0672 8.21659 24.8286C8.21659 27.59 10.4552 29.8286 13.2166 29.8286Z"
                    fill="white"
                  />
                </svg>
                <span className="text-red h5 absolute top-2 left-6 normal-case">
                  {price}
                </span>
              </div>
            </h2>
            <p className="h5 md:mb-[6px]">{name}</p>
            <p className="mb-[50px] md:mb-[37px]">{position}</p>

            <div className="flex w-fit items-center justify-between gap-2 rounded-full bg-white md:self-start">
              <div className="link-secondary text-blue flex items-center gap-2 p-1 md:gap-1">
                <div className="flex-center aspect-square w-10 rounded-full bg-gray-700 md:w-8">
                  <Svg className="md:w-3" id="phone" width="16" height="16" />
                </div>
                {phones?.[0] && (
                  <a className="h6" href={`tel:${phones?.[0].phone}`}>
                    {phones?.[0].phone}
                  </a>
                )}
              </div>

              <ModalForm toggle={<Button>Записаться</Button>} />
            </div>
          </div>

          <div className="relative ml-auto self-end md:mx-auto">
            <div className="absolute right-[-135px] bottom-[-505px] aspect-square w-[798px] rounded-full bg-[#D1DEF3] sm:right-[-156px] sm:bottom-[-326px] sm:w-[592px]" />
            <Media
              className="relative mr-[170px] w-[370px] md:w-[278px] lg:mr-0"
              resource={photo}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
